import packageJson from '../package.json';

// ----------------------------------------------------------------------

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  showDebugInfo: boolean;
  showDebugError: boolean;
  showDebugWarn: boolean;
  businessName: string;
  businessAddress: string;
  businessPhone: string;
  taxCode: string;
};

type ConfigFromWindow = Partial<ConfigValue> & { serverUrl?: string };

const injectedConfig = (window as any).__APP_CONFIG__ as ConfigFromWindow;

export const CONFIG: ConfigValue = {
  appName: injectedConfig?.appName ?? 'Quản lý vựa trái cây',
  appVersion: injectedConfig?.appVersion ?? packageJson.version,
  serverUrl: injectedConfig?.serverUrl ?? '',
  showDebugInfo: injectedConfig?.showDebugInfo ?? false,
  showDebugError: injectedConfig?.showDebugError ?? false,
  showDebugWarn: injectedConfig?.showDebugWarn ?? false,
  businessName: injectedConfig?.businessName ?? '__________________________',
  businessAddress: injectedConfig?.businessAddress ?? '__________________________',
  businessPhone: injectedConfig?.businessPhone ?? '__________________________',
  taxCode: injectedConfig?.taxCode ?? '_______________',
};